<template>
  <div>
    <h1 class="title">PANTALLA {{ numeroPantalla }} GENERADOR</h1>

    <HmiPantalla>
      <div class="content">
        <div class="screen-title">
          <HmiLabel label="GENERADOR" width="80%" height="100%" :size="4" color="cyan" border="solid 6px yellow">
          </HmiLabel>
          <div class="buttons">
            <HmiButton label="PREFERENCIA MAQUINA 1" :color="preferencia == '0' ? 'yellow' : 'silver'" width="50%"
              height="100%" :size="1.7" @click.native="cambiarMaquina(0)"></HmiButton>
            <HmiButton label="PREFERENCIA MAQUINA 2" :color="preferencia == '1' ? 'yellow' : 'silver'" width="50%"
              height="100%" :size="1.7" @click.native="cambiarMaquina(1)"></HmiButton>
          </div>
        </div>
        <div class="grid">
          <div class="custom-row">
            <HmiLabel label="KWh. PRODUCIDOS" color="cyan" width="50%" height="100%" :size="1.7"></HmiLabel>
            <HmiLabel :label="kwhProducidos" color="silver" width="50%" height="100%" :size="1.7"></HmiLabel>
          </div>
          <div class="custom-row">
            <HmiLabel label="ESPERA REARRAN. FALLO RED Min." color="cyan" width="50%" height="100%" :size="1.7">
            </HmiLabel>
            <HmiLabel :label="formato2digitos(hmiEsperaRearranqueFalloRed)" color="#56FF56" :editable="true" width="50%"
              height="100%" :size="1.7"
              @input="escrituraDM($event, direccionVariables.HMI_ESPERA_REARRANQUE_FALLO_RED_ESCRITURA, 1)"></HmiLabel>
            <HmiLabel label="MAXIMA POTENCIA KW" color="cyan" width="50%" height="100%" :size="1.7"></HmiLabel>
            <HmiLabel :label="formato3digitos(maxPotenciaKW)" color="#56FF56" :editable="true" width="50%" height="100%"
              :size="1.7" @input="escrituraDM($event, direccionVariables.MAX_POTENCIA_KW_ESCRITURA, 1)"></HmiLabel>
          </div>
          <div class="custom-row">
            <HmiLabel label="ESPERA REARRAN. PARADA Min." color="cyan" width="50%" height="100%" :size="1.7">
            </HmiLabel>
            <HmiLabel :label="formato2digitos(esperaRearranqueParada)" color="#56FF56" :editable="true" width="50%"
              height="100%" :size="1.7"
              @input="escrituraDM($event, direccionVariables.ESPERA_REARRANQUE_PARADA_ESCRITURA, 1)"></HmiLabel>
            <HmiLabel label="MINIMA POTENCIA KW" color="cyan" width="50%" height="100%" :size="1.7"></HmiLabel>
            <HmiLabel :label="formato2digitos(minimaPotenciaKW)" color="#56FF56" :editable="true" width="50%"
              height="100%" :size="1.7" @input="escrituraDM($event, direccionVariables.MINIMA_POTENCIA_KW_ESCRITURA, 1)">
            </HmiLabel>
          </div>
          <div class="custom-row">
            <HmiLabel label="HORAS FUNCIONAMIENTO" color="cyan" width="50%" height="100%" :size="1.7">
            </HmiLabel>
            <HmiLabel :label="formato6digitos(horasFuncionamiento)" color="silver" width="50%" height="100%" :size="1.7">
            </HmiLabel>
            <HmiLabel label="VALOR PALAS 100%" color="cyan" width="50%" height="100%" :size="1.7"></HmiLabel>
            <HmiLabel :label="formato4digitos(valorPalasAl100Porcentaje)" color="#56FF56" :editable="true" width="50%"
              height="100%" :size="1.7" @input="escrituraUINT($event, direccionVariables.valorPalasAl100Porcentaje, 1)">
            </HmiLabel>
          </div>
          <div class="custom-row">
            <HmiLabel label="MANIOBRAS 52G" color="cyan" width="50%" height="100%" :size="1.7"></HmiLabel>
            <HmiLabel :label="formato6digitos(maniobras52G)" color="silver" width="50%" height="100%" :size="1.7">
            </HmiLabel>
            <HmiLabel label="VALOR PALAS 0%" color="cyan" width="50%" height="100%" :size="1.7"></HmiLabel>
            <HmiLabel :label="formato3digitos(valorPalasAl0Porcentaje)" color="#56FF56" :editable="true" width="50%"
              height="100%" :size="1.7"
              @input="escrituraDM($event, direccionVariables.VALOR_PALAS_AL_0_PORCENTAJE_ESCRITURA, 1)"></HmiLabel>
          </div>
          <div class="custom-row">
            <HmiLabel label="% MAXIMO PALAS FUN. 2 MAQUINAS" color="cyan" width="50%" height="100%" :size="1.7">
            </HmiLabel>
            <HmiLabel :label="formato3digitos(porcentajeMaximoPalasFun2Maquinas) + ' %'" color="#56FF56" :editable="true"
              width="50%" height="100%" :size="1.7"
              @input="escrituraDM($event, direccionVariables.PORCENTAJE_MAXIMO_PALAS_FUN2_MAQUINAS_ESCRITURA, 1)">
            </HmiLabel>
            <HmiLabel :label="formato3digitos(aperturaPlacas) + ' %'" color="#FF00C0" width="50%" height="100%"
              :size="1.7"></HmiLabel>
            <HmiButton label="SALIR" color="silver" width="50%" height="100%" :size="1.7" @click.native="navigateToMenu">
            </HmiButton>
          </div>
        </div>
      </div>
    </HmiPantalla>
  </div>
</template>

<script>
import HmiLabel from "@/components/HMI/HmiLabel.vue";
import HmiButton from "@/components/HMI/HmiButton.vue";
import HmiPantalla from "@/components/HMI/HmiPantalla.vue";
export default {
  name: "GeneradorMasDatosPantalla",
  computed: {
    // Obtenemos el numero de pantalla en la que estamos trabajandos
    numeroPantalla() {
      return this.$route.params.numeroPantalla;
    },

    direccionVariables() {
      if (this.numeroPantalla == 1) {
        return {
          KWH_PRODUCIDOS_LECTURA_1: 121, // Correspondiente a Dm1163 (Canal 1)
          KWH_PRODUCIDOS_LECTURA_2: 122, // Correspondiente a Dm1163 (Canal 2)
          HMI_ESPERA_REARRANQUE_FALLO_RED_LECTURA: 9, // Correspondiente a Dm31
          HMI_ESPERA_REARRANQUE_FALLO_RED_ESCRITURA: 'Dm0031', // Correspondiente a Dm31
          ESPERA_REARRANQUE_PARADA_LECTURA: 8, // Correspondiente a Dm30
          ESPERA_REARRANQUE_PARADA_ESCRITURA: 'Dm0030', // Correspondiente a Dm30
          HORAS_FUNCIONAMIENTO_LECTURA_1: 51, // Correspondiente a Dm132 (Canal 1)
          HORAS_FUNCIONAMIENTO_LECTURA_2: 52, // Correspondiente a Dm132 (Canal 2)
          MANIOBRAS_52_G_LECTURA_1: 53, // Correspondiente a Dm134 (Canal 1)
          MANIOBRAS_52_G_LECTURA_2: 54, // Correspondiente a Dm134 (Canal 2)
          PORCENTAJE_MAXIMO_PALAS_FUN2_MAQUINAS_LECTURA: 31, // Correspondiente a Dm64
          PORCENTAJE_MAXIMO_PALAS_FUN2_MAQUINAS_ESCRITURA: 'Dm0064', // Correspondiente a Dm64
          APERTURA_PLACAS_LECTURA: 38, // Correspondiente a Dm86
          MAX_POTENCIA_KW_LECTURA: 13, // Correspondiente a Dm38
          MAX_POTENCIA_KW_ESCRITURA: 'Dm0038', // Correspondiente a Dm38
          MINIMA_POTENCIA_KW_LECTURA: 12, // Correspondiente a Dm36
          MINIMA_POTENCIA_KW_ESCRITURA: 'Dm0036', // Correspondiente a Dm36
          VALOR_PALAS_AL_100_PORCENTAJE_LECTURA: 34, // Correspondiente a Dm75
          VALOR_PALAS_AL_100_PORCENTAJE_ESCRITURA: 'Dm0075', // Correspondiente a Dm75
          VALOR_PALAS_AL_0_PORCENTAJE_LECTURA: 33, // Correspondiente a Dm73
          VALOR_PALAS_AL_0_PORCENTAJE_ESCRITURA: 'Dm0073', // Correspondiente a Dm73
        };
      } else {
        return {
          KWH_PRODUCIDOS_HMI_LECTURA_2: 122, // Correspondiente a Dm1363 (Canal 2)
          KWH_PRODUCIDOS_HMI_LECTURA_1: 121, // Correspondiente a Dm1163 (Canal 1)
          HMI_ESPERA_REARRANQUE_FALLO_RED_LECTURA: 9, // Correspondiente a Dm31
          HMI_ESPERA_REARRANQUE_FALLO_RED_ESCRITURA: 'Dm0031', // Correspondiente a Dm31
          ESPERA_REARRANQUE_PARADA_LECTURA: 14, // Correspondiente a Dm40
          ESPERA_REARRANQUE_PARADA_ESCRITURA: 'Dm0040', // Correspondiente a Dm40
          HORAS_FUNCIONAMIENTO_LECTURA_2: 56, // Correspondiente a Dm136 (Canal 2)
          HORAS_FUNCIONAMIENTO_LECTURA_1: 55, // Correspondiente a Dm136 (Canal 1)
          MANIOBRAS_52_G_LECTURA_2: 58, // Correspondiente a Dm138 (Canal 2)
          MANIOBRAS_52_G_LECTURA_1: 57, // Correspondiente a Dm138 (Canal 1)
          PORCENTAJE_MAXIMO_PALAS_FUN2_MAQUINAS_LECTURA: 32, // Correspondiente a Dm66
          PORCENTAJE_MAXIMO_PALAS_FUN2_MAQUINAS_ESCRITURA: 'Dm0066', // Correspondiente a Dm66
          APERTURA_PLACAS_LECTURA: 39, // Correspondiente a Dm88
          MAX_POTENCIA_KW_LECTURA: 16, // Correspondiente a Dm44
          MAX_POTENCIA_KW_ESCRITURA: 'Dm0044', // Correspondiente a Dm44
          MINIMA_POTENCIA_KW_LECTURA: 15, // Correspondiente a Dm42
          MINIMA_POTENCIA_KW_ESCRITURA: 'Dm0042', // Correspondiente a Dm42
          VALOR_PALAS_AL_100_PORCENTAJE_LECTURA: 36, // Correspondiente a Dm79
          VALOR_PALAS_AL_100_PORCENTAJE_ESCRITURA: 'Dm0079', // Correspondiente a Dm79
          VALOR_PALAS_AL_0_PORCENTAJE_LECTURA: 35, // Correspondiente a Dm77
          VALOR_PALAS_AL_0_PORCENTAJE_ESCRITURA: 'Dm0077', // Correspondiente a Dm77
        };
      }
    },
    direccionVariablesBit() {
      return {
        PREFERENCIA_MAQUINA_LECTURA: [142, 0],
        PREFERENCIA_MAQUINA_ESCRITURA: ['Hr0002', 7]
      }
    },
    kwhProducidos() {
      if (this.direccionVariables) {
        return (
          this.$store.state.lecturas[
          this.direccionVariables.KWH_PRODUCIDOS_LECTURA_2
          ] +
          this.$store.state.lecturas[
          this.direccionVariables.KWH_PRODUCIDOS_LECTURA_1
          ]
        );
      }
      return "00000000";
    },
    hmiEsperaRearranqueFalloRed() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.HMI_ESPERA_REARRANQUE_FALLO_RED_LECTURA
        ];
      }
      return "0000";
    },
    esperaRearranqueParada() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.ESPERA_REARRANQUE_PARADA_LECTURA
        ];
      }
      return "0000";
    },
    horasFuncionamiento() {
      if (this.direccionVariables) {
        return (
          this.$store.state.lecturas[
          this.direccionVariables.HORAS_FUNCIONAMIENTO_LECTURA_2
          ] +
          this.$store.state.lecturas[
          this.direccionVariables.HORAS_FUNCIONAMIENTO_LECTURA_1
          ]
        );
      }
      return "00000000";
    },
    maniobras52G() {
      if (this.direccionVariables) {
        return (
          this.$store.state.lecturas[
          this.direccionVariables.MANIOBRAS_52_G_LECTURA_2
          ] +
          this.$store.state.lecturas[
          this.direccionVariables.MANIOBRAS_52_G_LECTURA_1
          ]
        );
      }
      return "00000000";
    },
    porcentajeMaximoPalasFun2Maquinas() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables
            .PORCENTAJE_MAXIMO_PALAS_FUN2_MAQUINAS_LECTURA
        ];
      }
      return "0000";
    },
    aperturaPlacas() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.APERTURA_PLACAS_LECTURA
        ];
      }
      return "0000";
    },
    maxPotenciaKW() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.MAX_POTENCIA_KW_LECTURA
        ];
      }
      return "0000";
    },
    minimaPotenciaKW() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.MINIMA_POTENCIA_KW_LECTURA
        ];
      }
      return "0000";
    },
    valorPalasAl100Porcentaje() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.VALOR_PALAS_AL_100_PORCENTAJE_LECTURA
        ];
      }
      return "0000";
    },
    valorPalasAl0Porcentaje() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.VALOR_PALAS_AL_0_PORCENTAJE_LECTURA
        ];
      }
      return "0000";
    },
    preferencia() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.PREFERENCIA_MAQUINA_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.PREFERENCIA_MAQUINA_LECTURA[1]
        );
      }
      return '0';
    },
  },
  components: {
    HmiLabel,
    HmiButton,
    HmiPantalla,
  },

  mounted() {
    //Mandar a nodered entrada
    this.mandarEntrada();
    //Cuando se cierre la ventana enviar señal
    window.addEventListener("unload", this.mandarSalida);
  },
  destroyed() {
    //Mandar a nodered salida
    this.mandarSalida();
  },

  methods: {
    // Navegación a "Menu"
    navigateToMenu() {
      this.$router.push(`/pantalla/${this.numeroPantalla}`);
    },

    // Emitir evento salida
    mandarSalida() {
      this.$emit("mandar-pagina", "pagina/salida", "2", this.numeroPantalla);
    },

    // Emitir evento entrada
    mandarEntrada() {
      this.$emit(
        "mandar-pagina",
        "pagina/entrada",
        "2",
        this.numeroPantalla
      );
    },

    formato2digitos(dato) {
      return dato.substring(2, 4);
    },
    formato3digitos(dato) {
      return dato.substring(1, 4);
    },
    formato4digitos(dato) {
      dato = parseInt(dato, 16).toString();
      return dato.slice(-4).padStart(4, "0");
    },
    formato6digitos(dato) {
      return dato.substring(2, 8);
    },
    //Obtener bit
    obtenerBit(dato, posicion) {
      let intValue = parseInt(dato, 16);

      let binaryString = intValue.toString(2).padStart(16, "0");

      let bit = binaryString.charAt(binaryString.length - 1 - posicion);
      return bit;
    },

    escrituraUINT(value, direccion, canales) {
      const hexValue = parseInt(value, 10).toString(16).toUpperCase();

      const payload = {
        name: "escritura",
        direccion: direccion,
        valor: hexValue.padStart(4 * canales, "0"),
      };
      this.$emit("mandar-escritura", payload);
    },

    escrituraHR(direccionEscritura, valor) {
      // Determinar la dirección y el número de bit desde direccionEscritura
      let direccion = direccionEscritura[0].substring(2);
      let bit = direccionEscritura[1];

      // Construir el payload con el nuevo valor hexadecimal
      const payload = {
        name: "escrituraHR",
        direccion: direccion,
        valor: valor,
        bit: bit,
      };

      // Emitir el nuevo payload
      this.$emit("mandar-escritura", payload);
    },

    escrituraDM(value, direccion, canales) {
      direccion = direccion.substring(2);
      const payload = {
        name: "escrituraDM",
        direccion: direccion,
        valor: value.padStart(4 * canales, "0"),
      };
      this.$emit("mandar-escritura", payload);
    },

    // Cambiar preferencia maquina seleccionada
    cambiarMaquina(maquina) {
      this.escrituraHR(this.direccionVariablesBit.PREFERENCIA_MAQUINA_ESCRITURA, maquina.toString());
    },
  },

};
</script>

<style scoped>
.title {
  font-family: "Courier New", Courier, monospace !important;
  text-align: center;
  margin: 20px 20px 0px 20px;
}

.content {
  height: 100%;
}

.screen-title {
  display: flex;
  justify-content: center;
  gap: clamp(1px, 2vw - 5px, 20px);
  height: 15%;
}

.grid {
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  height: 85%;
  gap: clamp(1px, 2vw - 5px, 20px);
}

.buttons {
  display: flex;
  height: 100%;
  gap: clamp(1px, 2vw - 5px, 20px);
}

.custom-row {
  height: 16.66%;
  display: flex;
  gap: clamp(1px, 2vw - 5px, 20px);
}
</style>
